module.exports = __webpack_public_path__ + "img/tzgg.79b8ae0b.jpg";